import { startOnce } from '@app/adapters/tutorial'
import { createApp } from '@app/adapters/create-app'
import AccountMapping from '@app/application/account-mapping/components/account-mapping'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='table-account-mapping']").each(function () {
    const dataset = this.dataset

    const accountMappingApp = createApp(AccountMapping, {
      ...dataset,
      messageBusLastId: parseInt(dataset.messageBusLastId),
      saveBatchSize: parseInt(dataset.saveBatchSize),
      mappingListAccountTypes: JSON.parse(dataset.mappingListAccountTypes),
      isAiMappingProposalSupported:
        typeof dataset.isAiMappingProposalSupported !== 'undefined',
      externalMappingsAvailable:
        typeof dataset.hasExternalMappingProposals !== 'undefined',
      supportedLocales: JSON.parse(dataset.supportedLocales),
    })

    accountMappingApp.mount(this)

    /* TODO: Manually trigger the corresponding Userlane tutorial until they fix their JS performance
    See https://gitlab.silverfin.com/development/silverfin/-/issues/18067 */
    if (typeof dataset.tutorialId !== 'undefined') {
      startOnce(dataset.tutorialId)
    }
  })

  const clickableRows = document.querySelectorAll("[data-behaviour~='account']")

  clickableRows.forEach((row) => {
    const link = $(row).data('account-link')

    if (link) {
      row.addEventListener('click', (e) => {
        if (!e.target.classList.contains('icon-trash-o')) {
          e.preventDefault()
          e.stopPropagation()

          window.Turbolinks.visit(link)
        }
      })
    }
  })
})
